import * as React from 'react';
import { useGetTimberTypeQuery } from "../../../apis/TimberType.api";
import { PrimaryTimberType, TimberType } from "../../../types/models/TimberType";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: TimberType;
};

export const TimberTypeNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const TimberTypeName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetTimberTypeQuery(PrimaryTimberType.fromId(id))
    return (<TimberTypeNameDisplay data={data}/>)
}

export default TimberTypeName;
